import { LayoutOrientation } from 'core/constants/enums/LayoutOrientation.ts';
import { tabletBreakpoint } from 'core/layouts/ui-blocks/ReusableStyles';

export const actionMenuStyles = {
	actionMenuButtonStyles: {
		padding: '12px',
		gap: '10px',
		borderRadius: '4px',
		display: 'flex',
		flexDirection: 'row',
		backgroundColor: 'colors.dark4',
		alignItems: 'center',
		cursor: 'pointer',
		'& svg': {
			height: '20px',
			width: '20px',
		},
		'&:hover': {
			backgroundColor: 'colors.dark3',
		},
	},
	useImageButtonContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
		padding: '12px',
	},

	verticalLayoutContainer: {
		borderRadius: '4px',
		backgroundColor: 'colors.dark5',
		borderWidth: '1px',
		borderStyle: 'solid',
		borderColor: 'colors.dark4',
	},

	horizontalLayoutContainer: {
		width: '100%',
	},

	actionMenuButtonsContainer: (orientation) => ({
		display: orientation === LayoutOrientation.HORIZONTAL ? 'grid' : 'flex',
		gridTemplateRows: 'auto',
		gridTemplateColumns: {
			xs: 'repeat(auto-fill, minmax(150px, 1fr))',
			[tabletBreakpoint]: 'repeat(auto-fill, minmax(150px, 1fr))',
		},
		gridGap: '8px',
		flexDirection: 'column',
		gap: '16px',
		flexWrap: 'wrap',
	}),
};
